import { LOCAL_STORAGE_KEYS } from 'utils/constants/localStorageKeys';
import MAIN_SETTINGS from 'utils/constants/main';

export const changeLanguage = (payload) => (dispatch) => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.LANGUAGE, payload);

  dispatch({
    type: MAIN_SETTINGS.SET_LANG,
    payload,
  });
};
